import React, { Component } from 'react';
import SNavigationBar from 'shared/components/NavigationBar';
import Screens from 'shared/screens';
import LevelBar from '../LevelBar';
import CurrencyDisplay from '../CurrencyDisplay';
import ImageBW from '../ImageBoundsWrapper';
import TimeRemainingText from '../TimeRemainingText';
import Tier from '../Tier';
import { TooltipTypes } from 'shared/utils/tooltipConstants';
import Utils from 'shared/utils/index';
import MissionsProgressTopBar from '../MissionsProgress';
import ThemeContext from 'shared/context/ThemeContext';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import LottieAnimation from '../LottieAnimation/LottieAnimation';
import { ANIMATION_TYPE } from 'shared/components/LottieAnimation/constants';
import { FTUE_STEPS_KEYS } from 'shared/constants';

export default class NavigationBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resetAnimation: 0,
    };
  }

  _getNavStateAnimationClassName = shouldShowCoinBalance => {
    return shouldShowCoinBalance ? 'AnimationGoLobby' : 'AnimationGoInGame';
  };

  _getCurrencyContainerWidth = currency => {
    const currencyDigits = currency.toString().length;
    return currencyDigits < 8 ? 200 : currencyDigits < 15 ? currencyDigits * 35 : currencyDigits * 24;
  };

  initResetAnimationTimer = () =>
    this.setState(
      {
        resetAnimation: this.state.resetAnimation + 1,
      },
      () => this.resetAnimationHandler()
    );

  resetAnimationHandler = () => {
    let timer = 0;
    clearInterval(this.setTimerInterval);
    this.setTimerInterval = setInterval(() => {
      timer++;
      if (timer > 30) {
        this.initResetAnimationTimer();
      }
    }, 1000);
  };

  checkTabVisibility = () => {
    if (document.visibilityState === 'visible') {
      clearInterval(this.setTimerInterval);
      this.initResetAnimationTimer();
    }
  };

  componentDidMount() {
    this.resetAnimationHandler();
    document.addEventListener('visibilitychange', this.checkTabVisibility);
  }

  componentWillUnmount() {
    clearInterval(this.setTimerInterval);
    window.removeEventListener('visibilitychange', this.checkTabVisibility);
  }

  render() {
    const themeContext = this.context;

    return (
      <SNavigationBar
        {...this.props}
        render={
          /**
            @param {Object} args
            @param {import('shared/api/Constants').DTS} args.dts
           */
          args => {
            const {
              IapButtonState,
              limitedTimeOffer,
              coins,
              loyalty,
              showModal,
              navigateBack,
              showCoinBalance,
              isHome,
              isMissions,
              showActiveTracker,
              changeTooltipType,
              tooltipType,
              ftueStep,
              showLinkLoyaltyCardSetting,
              showHomeButton,
              tooltipDetails,
              shouldShowTooltip,
              showMissionsProgressBar,
            } = args;

            // If IapButtonState is 2 (NoSaleDeal) or 3 (SaleDeal), use a split button
            const splitButton = IapButtonState === 2 || IapButtonState === 3;
            let leftButton = null;
            let rightButton = null;
            let leftButtonIbw = null;
            let rightButtonIbw = require(asset`images/Top_Bar_Assets/IAP_Button_Right.ibw`);
            if (splitButton) {
              leftButtonIbw = require(asset`images/Top_Bar_Assets/IAP_Button_Left.ibw`);
              // 2 (NoSaleDeal)
              if (IapButtonState === 2) {
                leftButton = require(asset`images/Top_Bar_Assets/IAP_SplitGreen@3x.png`);
                rightButton = require(asset`images/Top_Bar_Assets/IAP_SplitPink@3x.png`);
              }
              // 3 (SaleDeal)
              else if (IapButtonState === 3) {
                leftButton = require(asset`images/Top_Bar_Assets/IAP_SplitSale@3x.png`);
                rightButton = require(asset`images/Top_Bar_Assets/IAP_SplitPink@3x.png`);
              }
            } else {
              leftButtonIbw = require(asset`images/Top_Bar_Assets/IAP_Button_Whole.ibw`);
              // 0 (NoSale)
              if (IapButtonState === 0) {
                leftButton = require(asset`images/Top_Bar_Assets/IAP_Whole@3x.png`);
              }
              // 1 (Sale)
              else if (IapButtonState === 1) {
                leftButton = require(asset`images/Top_Bar_Assets/IAP_WholeSale@3x.png`);
              }
            }

            const checkLoyaltyBarWidth = () => {
              if (showLinkLoyaltyCardSetting) {
                return showActiveTracker ? '7vmin' : 200;
              } else {
                return showActiveTracker ? '7vmin' : 1000;
              }
            };

            return (
              <div className="navBar" style={themeContext.NavigationBar.TopBar}>
                <LottieAnimation
                  animationStyle={themeContext.NavigationBar.BarLineAnimation}
                  startDelay={2000}
                  loopDelay={3000}
                  animationType={ANIMATION_TYPE.NAVIGATION_BAR_ANIMATION}
                  autoplay={true}
                  speed={0.93}
                  needToReset={this.state.resetAnimation}
                />

                <div
                  style={{
                    backgroundImage: `url(${require(asset`images/Top_Bar_Assets/Backing@3x.png`)})`,
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    top: 0,
                    zIndex: -100,
                    backgroundSize: '100% 100%',
                  }}
                />

                <div style={themeContext.NavigationBar.BarSection}>
                  {/* left */}
                  <div
                    className="flexBarSection"
                    style={{
                      flex: 1,
                      height: '100%',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      paddingLeft: '1rem',
                      paddingRight: '1rem',
                    }}
                  >
                    <div
                      onClick={showHomeButton() ? navigateBack : () => {}}
                      className={`HomeIcon ${
                        isHome || ftueStep > FTUE_STEPS_KEYS.HIGHLIGHT_A_GAME || !showHomeButton() ? 'disable' : ''
                      } ${this._getNavStateAnimationClassName(!showHomeButton())}`}
                      style={{ margin: 0 }}
                    >
                      <img
                        src={require(asset`images/Top_Bar_Assets/Home_Button@3x.png`)}
                        alt="home"
                        style={{
                          height: 50,
                          width: 50,
                        }}
                      />
                    </div>
                    <div style={{ display: showCoinBalance || isMissions ? 'flex' : 'none', width: '60%' }}>
                      <CurrencyDisplay
                        source={require(asset`images/Top_Bar_Assets/Coin_Icon@3x.png`)}
                        ibw={require(asset`images/Top_Bar_Assets/Coin_Icon.ibw`)}
                        manualAssetScale={3}
                        style={{
                          paddingRight: '1rem',
                          maxWidth: null,
                          flex: '1 1 50%',
                        }}
                        imgStyle={{
                          height: 55,
                          width: 65,
                          left: -27,
                          top: -14,
                        }}
                        value={coins}
                        iconType="coins"
                        changeTooltipType={changeTooltipType}
                        tooltipType={tooltipType}
                        currencyType={TooltipTypes.COINS}
                        containerWidth={this._getCurrencyContainerWidth(coins)}
                        containerHeight={90}
                        additionalWrapperClassNames={this._getNavStateAnimationClassName(showCoinBalance || isMissions)}
                        isCoinsGlowAnimationStopped={this.props.isCoinsGlowAnimationStopped}
                        isCoinsGlowAnimationEnabled={this.props.isCoinsGlowAnimationEnabled}
                      />
                    </div>
                    <div
                      className={`LevelBarWrapper ${this._getNavStateAnimationClassName(showCoinBalance)}`}
                      style={{
                        flex: '1 1 50%',
                        height: '100%',
                        flexDirection: 'row',
                        paddingHorizontal: '2%',
                      }}
                    >
                      <LevelBar
                        style={{
                          position: 'relative',
                          flex: 1,
                          justifyContent: Utils.ieVersion() !== 0 ? 'flex-start' : 'center',
                          maxWidth: '100%',
                        }}
                        navigation={this.props.navigation}
                        changeTooltipType={changeTooltipType}
                        tooltipType={tooltipType}
                        isCoinVisible={showCoinBalance}
                      />
                    </div>
                  </div>
                  {/* middle */}
                  <div style={themeContext.NavigationBar.MiddleSection}>
                    <LottieAnimation
                      animationType={ANIMATION_TYPE.BUY_BUTTON_ANIMATION}
                      animationStyle={styles.buttonShineStyle}
                      speed={0.85}
                      startDelay={4500}
                      loopDelay={8000}
                      needToReset={this.state.resetAnimation}
                    />
                    <LottieAnimation
                      animationType={ANIMATION_TYPE.BUY_BUTTON_SPARKLE_ANIMATION}
                      aspectRatioSetting="xMidYMid meet"
                      animationStyle={styles.buttonSparklingStyle}
                      speed={0.4}
                      startDelay={8500}
                      loopDelay={7500}
                      needToReset={this.state.resetAnimation}
                    />

                    <ImageBW
                      style={{
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        height: '6rem',
                        width: '100%',
                      }}
                      source={require(asset`images/Top_Bar_Assets/IAP_Backing@3x.png`)}
                      ibw={require(asset`images/Top_Bar_Assets/IAP_Backing.ibw`)}
                      manualAssetScale={3}
                      innerStyle={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'flex-start',
                        justifyContent: 'center',
                      }}
                    >
                      <ImageBW
                        source={leftButton}
                        ibw={leftButtonIbw}
                        manualAssetScale={3}
                        onClick={() => showModal(Screens.Shop)}
                        style={{
                          flex: 1,
                          height: '100%',
                          pointerEvents: 'all',
                          cursor: 'pointer',
                        }}
                        innerStyle={{
                          display: 'flex',
                          alignItems: 'center',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }}
                      >
                        <div
                          qa-id="buyButton"
                          className="BuyButton"
                          style={{ fontSize: splitButton ? '24pt' : '30pt' }}
                        >
                          {IapButtonState === 0 || IapButtonState === 2
                            ? getText(TEXT_KEY.BUY)
                            : getText(TEXT_KEY.SALE)}
                        </div>
                      </ImageBW>
                      {splitButton && (
                        <ImageBW
                          source={rightButton}
                          ibw={rightButtonIbw}
                          manualAssetScale={3}
                          onClick={() => showModal(Screens.LimitedTimeOffer)}
                          style={{
                            flex: 1,
                            height: '100%',
                            pointerEvents: 'all',
                            cursor: 'pointer',
                          }}
                          innerStyle={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <div
                            className="DealButton"
                            style={{
                              lineHeight: 1,
                              display: 'flex',
                              justifyContent: 'center',
                            }}
                          >
                            {getText(TEXT_KEY.DEAL)}
                          </div>
                          <div className="DealButtonTimer">
                            <TimeRemainingText until={limitedTimeOffer.OFFER_END_TIME} />
                          </div>
                        </ImageBW>
                      )}
                    </ImageBW>
                  </div>
                  {/* right */}
                  <div
                    className="flexBarSection"
                    style={{
                      flex: 1,
                      height: '100%',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      paddingLeft: '1rem',
                      paddingRight: '1rem',
                    }}
                  >
                    <CurrencyDisplay
                      source={require(asset`images/Top_Bar_Assets/Loyalty_Star_Icon@3x.png`)}
                      ibw={require(asset`images/Top_Bar_Assets/Loyalty_Star_Icon.ibw`)}
                      manualAssetScale={3}
                      style={{
                        maxWidth: checkLoyaltyBarWidth(),
                        ...(showMissionsProgressBar && {
                          ...(showLinkLoyaltyCardSetting
                            ? { ...themeContext.NavigationBar.LoyaltyCurrencyWrapperStyle }
                            : { ...themeContext.NavigationBar.LoyaltyCurrencyWrapperStyleWithoutCard }),
                        }),
                        ...(showActiveTracker && !showMissionsProgressBar && { left: 25 }),
                      }}
                      imgStyle={{
                        ...themeContext.NavigationBar.LoyaltyCurrencyIconStyle,
                        marginLeft: showMissionsProgressBar && '16px',
                      }}
                      value={loyalty}
                      iconType="loyalty"
                      enableOnClick={true}
                      onClick={() => showModal(Screens.RewardCenter)}
                      imageOnly={showMissionsProgressBar}
                      changeTooltipType={changeTooltipType}
                      tooltipType={tooltipType}
                      currencyType={TooltipTypes.LOYALTY}
                      containerWidth={this._getCurrencyContainerWidth(loyalty)}
                      containerHeight={90}
                      innerStyle={{ paddingLeft: 15 }}
                    />

                    {showMissionsProgressBar && (
                      <MissionsProgressTopBar
                        showLinkLoyaltyCardSetting={showLinkLoyaltyCardSetting}
                        tooltipDetails={tooltipDetails}
                        shouldShowTooltip={shouldShowTooltip}
                        navigation={this.props.navigation}
                        isMissionsScreen={isMissions}
                      />
                    )}

                    {showLinkLoyaltyCardSetting && (
                      <Tier
                        navigation={this.props.navigation}
                        showActiveTracker={showActiveTracker}
                        changeTooltipType={changeTooltipType}
                        tooltipType={tooltipType}
                        needToReset={this.state.resetAnimation}
                      />
                    )}
                    <button
                      className="proto"
                      onClick={() => showModal(Screens.Settings)}
                      style={{
                        padding: 0,
                        marginLeft: '1rem',
                        background: 'none',
                        border: 'none',
                        maxWidth: '25%',
                      }}
                    >
                      <ImageBW
                        source={require(asset`images/Top_Bar_Assets/Menu_Hamburger@3x.png`)}
                        ibw={require(asset`images/Top_Bar_Assets/Menu_Hamburger.ibw`)}
                        style={{ height: 50, width: 50 }}
                      />
                    </button>
                  </div>
                </div>
              </div>
            );
          }
        }
      />
    );
  }
}

NavigationBar.contextType = ThemeContext;

const styles = {
  buttonShineStyle: {
    width: '100%',
    zIndex: 10,
  },
  buttonSparklingStyle: {
    width: '100%',
    zIndex: 10,
    top: -10,
  },
};

